import { createTRPCContext } from '@trpc/tanstack-react-query'
import type { TRPCRouter } from '@/trpc/router.ts'

export const { TRPCProvider, useTRPC } = createTRPCContext<TRPCRouter>()
